// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1vEJF","actionsCol":"EnrolledClinics_actionsCol__CAM01"};